import posthog, { CaptureOptions, Properties } from 'posthog-js';

export function capturePosthogEvent(
	eventName: string,
	properties?: Properties | null,
	options?: CaptureOptions,
) {
	posthog?.capture(eventName, properties, options);
}
